import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/api/client";

// Per-tenant policy view. Plugin availability is the load-bearing piece
// pilot users need to see (which calculator backends the tenant has
// access to per the per-tenant image variants — P1-PLUGINS §6.3).
// Backend endpoint lands in PR-07; until then 404s and tests stub.

export interface TenantPlugin {
  plugin_id: string; // "quick", "psi4", "mace", "qdpi2", "xtb", "ffp_opt"
  display_name: string;
  // Whether the tenant's per-tenant image variant includes this plugin.
  available: boolean;
  // Optional licensing note — what the tenant pays for it.
  license_note: string | null;
}

export interface TenantInfo {
  tenant_id: string;
  slug: string;
  display_name: string;
  security_level: number; // L1, L2, L3 per P1-PLUGINS §6.6
  plugins: TenantPlugin[];
}

export const TENANT_INFO_QUERY_KEY = ["tenant", "info"] as const;

export function useTenantInfo() {
  return useQuery({
    queryKey: TENANT_INFO_QUERY_KEY,
    queryFn: async (): Promise<TenantInfo> => apiFetch<TenantInfo>("/api/tenant"),
    staleTime: 5 * 60_000,
  });
}
